<template>
    <v-overlay class="text-center" :value="overlayUpdate" z-index="999999999" opacity="0.7">
        <loading-spinner/>
        <div>{{ $t('common.download_update') }}</div>
        <small>{{ $t('common.auto_reload') }}</small>
    </v-overlay>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {LoadingSpinner},
    computed: {
        ...mapState(['overlayUpdate']),
    },
}
</script>